import { MapPin, Palette, Maximize2, Square, Star, Type } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

export type Category = 'map' | 'style' | 'frames-and-size' | 'icons' | 'text';

// Ikona frame s šipkami uvnitř
const FrameWithArrowsIcon = ({ className }: { className?: string }) => (
  <div className={cn("relative", className)}>
    <Square className="w-5 h-5" />
    <Maximize2 className="w-3 h-3 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
  </div>
);

interface CategoryNavigationProps {
  selectedCategory: Category;
  onCategorySelect: (category: Category) => void;
  selectedMapIconId?: string | null;
  onCloseMapIconEditor?: () => void;
}

const categories = [
  { id: 'map' as Category, icon: MapPin, labelKey: 'settings.map' },
  { id: 'style' as Category, icon: Palette, labelKey: 'settings.style' },
  { id: 'text' as Category, icon: Type, labelKey: 'settings.text' },
  { id: 'frames-and-size' as Category, icon: FrameWithArrowsIcon, labelKey: 'settings.framesAndSize' },
  { id: 'icons' as Category, icon: Star, labelKey: 'settings.icons' },
];

export function CategoryNavigation({ selectedCategory, onCategorySelect, selectedMapIconId, onCloseMapIconEditor }: CategoryNavigationProps) {
  const { t } = useTranslation();
  
  const handleCategoryClick = (category: Category) => {
    // Pokud je vybrána ikona v mapě a kliknu na kategorii 'icons', zrušit výběr ikony
    if (selectedMapIconId && category === 'icons' && onCloseMapIconEditor) {
      onCloseMapIconEditor();
    }
    onCategorySelect(category);
  };
  
  return (
    <div className="w-16 flex flex-col items-center py-6">
      <div className="bg-white-cream/70 backdrop-blur-lg rounded-2xl p-3 border border-wood-warm/30 shadow-xl">
        {categories.map((category) => {
          const IconComponent = category.icon;
          const isSelected = selectedCategory === category.id;
          
          return (
            <button
              key={category.id}
              onClick={() => handleCategoryClick(category.id)}
              className={cn(
                "w-12 h-12 flex items-center justify-center rounded-xl transition-all duration-300 group mb-4 last:mb-0",
                isSelected 
                  ? "bg-green-dark text-white-pure shadow-lg" 
                  : "text-charcoal-medium hover:text-charcoal-dark hover:bg-beige-warm"
              )}
              title={t(category.labelKey)}
            >
              <IconComponent className="w-5 h-5" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
